import { PricingTier } from 'components/default/Informational/PricingTiers/PricingTierBox/PricingTierBox.types';

export const DEFAULT_FREE_SESSIONS: number = 500; // default free sessions for new users
export const DEFAULT_AFFILIATE_RATE: string = '30%'; // must match same variable from server
export const MINIMUM_PAYMENT_THRESHOLD: string = '$10 USD';
export const MINIMUM_QUALIFICATION_TIME_QTY: number = 3;
export const MINIMUM_QUALIFICATION_TIME_UNIT: string = 'month';
export const MINIMUM_QUALIFICATION_TIME_SINGULAR: string = `${MINIMUM_QUALIFICATION_TIME_QTY} ${MINIMUM_QUALIFICATION_TIME_UNIT}`;
export const MINIMUM_QUALIFICATION_TIME_PLURAL: string = `${MINIMUM_QUALIFICATION_TIME_QTY} ${MINIMUM_QUALIFICATION_TIME_UNIT}s`;
export const COOKIE_DURATION: string = '1 year';
export const DEFAULT_CURRENCY_SYMBOL: string = '£';
export const HOSTNAME: string = 'topuptest.com'; // @todo: change with new projects
export const PROTOCOL: string = 'https';
// export const SITE_URL: string = 'http://localhost:3000'; // @todo: change back to `${PROTOCOL}://www.${HOSTNAME}`;
export const SITE_URL: string = `${PROTOCOL}://www.${HOSTNAME}`; // for local dev convenience, could use 'http://localhost:3000'
export const NO_MODAL_OVERLAY: { [key: string]: unknown } = {
    overlay: {
        background: 'unset',
        top: 'unset',
    },
};
export const DEFAULT_ITEMS_PER_PAGE = 10;
export enum TARGET_DEVICES {
    MOBILES = 1,
    TABLETS = 2,
    DESKTOPS = 3,
}
export const TRACKING_SCRIPT_PATH = `${window.location.origin}/scripts/tracking/track.js`;
export const PAYMENT_SUCCESS_REDIRECT_PATH: string = '/payment-success';
export const PAYMENT_CANCEL_REDIRECT_PATH: string = '/payment-cancelled';
// note: ensure PAYMENT_SUCCESS_REDIRECT_PATH & PAYMENT_CANCEL_REDIRECT_PATH correspond with BE global variables
export const PAYMENT_METHOD_UPDATE_SUCCESS_REDIRECT_URL: string = '/payment-method-update-success';
export const PAYMENT_METHOD_UPDATE_CANCEL_REDIRECT_URL: string = '/payment-method-update-cancelled';
export enum AVATAR_VALUES { // @todo: check when going to prod as these values may be WRONG
    OTHER_GOAL = '6e4972c3-0f98-4e10-830e-c97b6436a20d', // ab_testing_goals table
    OTHER_INDUSTRY = 'c3202e8b-03df-4b52-b5d0-51b3d72cb4b8', // industries table
    OTHER_PRIMARY_OBJECTIVE = 'd847f478-4998-4a29-8f76-6746db31a200', // website_objectives table
    OTHER_JOB_CATEGORY = '37d4c20a-75f3-40d7-8b36-4a1b5d45f9c8', // job_categories table
    OTHER_COMPETITOR = '008f5156-12a3-449d-a611-a27a8f50ff58', // previous_platforms table
}
export const VIDEO_EMBED_URLS = Object.freeze({
    MAIN_VIDEO: 'https://www.youtube.com/embed/zu6S60b6JdI?si=TKoyYbjXGvUaDtGv',
    HEADLINE_TEST_VIDEO: 'https://www.youtube.com/embed/2IDCs8l6FUc?si=qFNqhiibgDLg-V3k',
    ALEX_HORMOZI_HEADLINE_TEST_VIDEO:
        'https://www.youtube.com/embed/9Dc2UQbQNTo?si=dbnRhOWxC-A6iFhs',
});
export const FREE_SESSIONS_OFFER_COUNT = '1,000';
export const LANDING_PAGE_BENEFIT_CHECKS = [
    `${FREE_SESSIONS_OFFER_COUNT} free sessions`,
    'Video tutorial',
    'Takes 5-10 minutes',
    'Free recurring sessions',
    'No tests = conversion leaks',
];
export const LANDING_PAGE_EBOOK_BENEFIT_CHECKS = [
    'Ready-to-run ideas that reveal what converts best',
    'Quick & Easy Setup',
    'Low-effort, High-impact',
    'Confident in Results (data-driven)',
    'Forever Free Starter Option',
    'No tests = conversion leaks',
];

/**
 * Ordered from highest minSessions down to lowest so consumers can find the first matching
 * tier for a given sessions count (or iterate as needed).
 *
 * Uses the UI PricingTier shape (minSessions, maxSessions, unitPrice, savingPercentage?)
 */
export const PRICING_TIERS: ReadonlyArray<PricingTier> = Object.freeze([
    { minSessions: 10000, maxSessions: 'max', unitPrice: 0.007, savingPercentage: 30 },
    { minSessions: 5000, maxSessions: 9999, unitPrice: 0.008, savingPercentage: 20 },
    { minSessions: 0, maxSessions: 4999, unitPrice: 0.01 },
]);

// convenience named exports (useful for quick references)
export const PRICE_HIGH = PRICING_TIERS[0].unitPrice;
export const PRICE_MID = PRICING_TIERS[1].unitPrice;
export const PRICE_BASE = PRICING_TIERS[2].unitPrice;
